module.exports = __webpack_public_path__ + "img/9788998791261.43f25ea1.jpg";